<template>
  <modal ref="modal">
    <template v-slot:header>
       <div class="text-center"><a class="text-blue-800" href="https://www.annkissam.com/" target="_blank">Annkissam</a></div>
    </template>
    <div><p class="text-center">Developed a robust system that collects timesheet data from different organizations and calculates <a class="text-blue-500 hover:text-blue-800" href="https://www.dol.gov/general/topic/workhours/overtime" target="_blank">overtime</a> and <a class="text-blue-500 hover:text-blue-800" href="https://www.dol.gov/general/topic/workhours/traveltime" target="_blank">travel</a> time for employees across the organizations to comply with requirements from the <a class="text-blue-500 hover:text-blue-800" href="https://www.dol.gov/" target="_blank">United States Department of Labor</a>.</p>
      <br/>
      <div class="bg-gray-300 font-mono p-2">
    <p>- Used <a class="text-blue-500 hover:text-blue-800" href="https://www.ruby-lang.org/en/" target="_blank">Ruby</a> on <a class="text-blue-500 hover:text-blue-800" href="https://rubyonrails.org/" target="_blank">Rails</a> to build the system and <a class="text-blue-500 hover:text-blue-800" href="https://www.mysql.com/" target="_blank">mySQL</a> for the database.</p>
    <p>- Used <a class="text-blue-500 hover:text-blue-800" href="https://developers.arcgis.com/" target="_blank">ArcGIS</a> and <a class="text-blue-500 hover:text-blue-800" href="https://developer.here.com/" target="_blank">HERE</a> APIs to obtain geocode from addresses then calculate travel time between addresses.</p></div>
    </div>
  </modal>
</template>
<script>
  import Modal from './Modal.vue'

  export default {
    components: {
      Modal
    },

    methods: {
      open () {
        this.$refs.modal.open()
      },
      close () {
        this.$refs.modal.close()
      }
    }
  }
</script>
<style>
  a {
    color:;
  }
</style>
